import { TournamentStatus } from "model/Tournament/Tournament";
import styled from "styled-components";
import { CenterFlexRow, FlexColumn, FlexRow } from "styles/layout";
import { Theme } from "theme";

// todo - extract similarities with Match Status Pill
const getStatusBackground = (status: TournamentStatus) => {
  switch (status) {
    case "Completed":
      return Theme.matchStatusCompleteBackground;
    case "Ongoing":
      return Theme.matchStatusInProgressBackground;
    case "Upcoming":
      return Theme.matchStatusUpcomingBackground;
    default:
      return "white";
  }
};

const getStatusForeground = (status: TournamentStatus) => {
  switch (status) {
    case "Completed":
      return Theme.matchStatusCompleteForeground;
    case "Ongoing":
      return Theme.matchStatusInProgressForeground;
    case "Upcoming":
      return Theme.matchStatusUpcomingForeground;
    default:
      return "black";
  }
};

export const TournamentsOptionsContainer = styled(CenterFlexRow)`
  align-items: flex-start;
  column-gap: 50px;
  @media (max-width: 1100px) {
    column-gap: 15px;
  }

  @media (max-width: 800px) {
    column-gap: 12px;
  }

  @media (max-width: 500px) {
    flex-direction: column;
    row-gap: 8px;
    align-items: stretch;
  }
`;

export const TournamentsOptionsColumn = styled(FlexColumn)`
  align-items: flex-start;
  flex-grow: 1;
  flex-basis: 0;
`;

export const TournamentOptions = styled(FlexColumn)`
  width: 100%;
  row-gap: 10px;

  @media (max-width: 700px) {
    row-gap: 7px;
  }
`;

export const OptionContainer = styled(FlexRow)`
  padding: 10px ${Theme.bigPanelPaddingHorizontal};
  @media (max-width: 900px) {
    padding: 8px 16px;
  }

  @media (max-width: 900px) {
    padding: 8px ${Theme.smallPanelPadding};
  }
`;

export const MetadataColumn = styled(FlexColumn)`
  row-gap: 20px;
  flex-grow: 1;
`;

export const TournamentDetails = styled.div`
  font-size: 12.5pt;
  max-width: 240px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: clip;

  span {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow-x: clip;
  }

  @media (max-width: 700px) {
    font-size: 11pt;
    max-width: 210px;
  }
`;

export const TournamentLogoContainer = styled.div`
  width: 75px;
  height: 75px;
  margin-left: 20px;

  @media (max-width: 800px) {
    margin-left: 14px;
    width: 60px;
    height: 60px;
  }

  @media (max-width: 700px) {
    display: none;
  }

  @media (max-width: 500px) {
    display: block;
  }

  @media (max-width: 320px) {
    display: block;
    width: 45px;
    height: 45px;
  }
`;

export const TournamentStatusPillContainer = styled.div`
  margin-right: auto;
  display: flex;
  justify-content: center;
`;

// todo - extract common with matches?
export const TournamentStatusPill = styled.div<{
  status: TournamentStatus;
}>`
  width: 70px;
  text-align: center;
  border-radius: 8px;
  padding: 3px;
  font-size: 10pt;
  background: ${({ status }) => getStatusBackground(status)};
  border: ${({ status }) => `1px solid ${getStatusForeground(status)}`};
  color: ${({ status }) => getStatusForeground(status)};

  @media (max-width: 700px) {
    padding: 2px;
    font-size: 9pt;
    width: 65px;
  }
`;

export const TournamentDate = styled.div`
  margin-left: auto;
  font-size: 10.5pt;

  @media (max-width: 700px) {
    font-size: 10pt;
  }
`;
